import React, { Component } from "react";
import BuildCatalog from "./buildCatalog";
import StorePreview from "./storePreview";
import{Steps,Popover}from 'antd'
class BuildMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreview: false,
      products: [],
    };
  }
  onChangePreview = () => {
    this.setState({
      isPreview: !this.state.isPreview,
    });
  };
  onAdd = (data) => {
    this.setState({
      products: data,
    });
  };
  render() {
    // const { Step } = Steps;
    // const customDot = (dot, { status, index }) => (
    //   <Popover
    //     content={
    //       <span>
    //         step {index} status: {status}
    //       </span>
    //     }
    //   >
    //     {dot}
    //   </Popover>
    // );
    return (
      <div>
          {/* <Steps current={this.props.count} progressDot={customDot}>
            <Step title="Register" />
            <Step title="Create Profile" />
            <Step title="Add your plant" />
            <Step title="Personlize" />
            <Step title="Build Catalog" />
            <Step title="Subscription" />
          </Steps> */}
        {!this.state.isPreview ? (
          <BuildCatalog
            onChangePreview={this.onChangePreview}
            onAdd={this.onAdd}
            {...this.props}
          />
        ) : (
          <StorePreview
            onChangePreview={this.onChangePreview}
            products={this.state.products}
            {...this.props}
          />
        )}
      </div>
    );
  }
}
export default BuildMain;
